import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { RouterUtils } from '../router.utils';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
  segments: string[];
}

export class CustomRouterSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    return RouterUtils.extractActivatedRouterData(routerState);
  }
}
